import { render, staticRenderFns } from "./LandingBanner.vue?vue&type=template&id=bd53070e&scoped=true"
import script from "./LandingBanner.vue?vue&type=script&lang=js"
export * from "./LandingBanner.vue?vue&type=script&lang=js"
import style0 from "./LandingBanner.vue?vue&type=style&index=0&id=bd53070e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd53070e",
  null
  
)

export default component.exports